export default [
  // 企业相关
  {
    path: "/enterprisepage",
    name: "enterprisepage",
    component: () =>
      import ("@/CommonDP/pages/enterprise/index.vue")
  },
  {
    path: "/joinEnterprise",
    name: "joinEnterprise",
    component: () =>
      import ("@/CommonDP/pages/enterprise/joinEnterPrises.vue")
  },
  {
    path: "/consentagree",
    name: "consentagree",
    component: () =>
      import ("@/CommonDP/pages/enterprise/consenTagrees.vue")
  },
  {
    path: "/fillinformation",
    name: "fillinformation",
    component: () =>
      import ("@/CommonDP/pages/enterprise/fillInforMations.vue")
  },
  {
    path: "/creationcomplete",
    name: "creationcomplete",
    component: () =>
      import ("@/CommonDP/pages/enterprise/creationCompletes.vue")
  },
  {
    path: "/businesslicense",
    name: "businesslicense",
    component: () =>
      import ("@/CommonDP/pages/enterprise/businessLicenses.vue"),
    hidden: true
  },
  // 没有能用的页面
  {
    path: "/noenterprise",
    name: "noenterprise",
    component: () =>
      import ("@/CommonDP/pages/enterprise/noEnterPrises.vue")
  },
  {
    path: "/changeenterprise",
    name: "changeenterprise",
    component: () =>
      import ("@/CommonDP/pages/enterprise/changeEnterprises.vue")
  }
];
